import {
  createHeaderBiddingLabel,
  createOptOutTargetingConfig,
  createTestTargetConfig,
  createWebappName,
  createWebVersionTarget,
} from '@/features/advertisement/components/gpt/configGpt'
import { createHashedDeviceIdLabel } from '@/features/advertisement/components/gpt/deviceGpt'
import { GPT_KEYS } from '@/features/advertisement/constants/gpt'
import { type GptTargeting } from '@/features/advertisement/types/adConfig'
import { type GA_PAGE_TYPE, GPT_PAGE_TYPE } from '@/lib/ga/constants/datalayer'

export const getGenericTargetingKeys = ({
  hasUserOptedOutTargeting,
  pageType,
  ptgValues,
}: {
  hasUserOptedOutTargeting: boolean
  pageType: GA_PAGE_TYPE
  ptgValues: string[]
}): GptTargeting[] => {
  /** General Page Keys */
  const genericKeys: GptTargeting[] = [
    /** DEVICE */
    createHashedDeviceIdLabel(),
    /**
     * These ptg values are related to vcadmin and there is a heap of logic on BOX in Trackable.java for generating them.
     * On legacy, googletag.pubads().getTargeting('ptg') always returns an array of identical values.
     * So, for the time being, we will use hardcoded values.
     */
    { key: GPT_KEYS.PTG_LABEL, value: ptgValues },

    /** PAGE */
    { key: GPT_KEYS.PAGE_TYPE_LABEL, value: pageType },
    { key: GPT_KEYS.PAGE_TYPE_LABEL_KJ, value: GPT_PAGE_TYPE[pageType] },
    createWebappName(),

    /**
     * CONFIG
     */
    createHeaderBiddingLabel(),
    createOptOutTargetingConfig(hasUserOptedOutTargeting),
  ]

  const testTarget = createTestTargetConfig()
  if (testTarget) genericKeys.push(testTarget)

  const webVersionTarget = createWebVersionTarget()
  if (webVersionTarget) genericKeys.push(webVersionTarget)

  return genericKeys
}
